import api from './../../api/api'

export default {

  organisations: async (page, take, sortBy, sortOrder, search,filters) => {
    return api.get(`api/organisations?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  create: async organisation => {
    return api.post('api/organisations',organisation)
  },

  get: async id => {
    return api.get('api/organisations/' + id)
  },

  update: async (id,organisation) => {
    return api.put('api/organisations/' + id, organisation)
  },

  delete: async id => {
    return api.delete('api/organisations/' + id)
  }
}
